import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Divider, Grid, Paper,
    CircularProgress, Button, Tab, Tabs
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import apiUrl from '../../Config';

const BookingDetails = () => {
    const { bookingId } = useParams();
    const navigate = useNavigate();

    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(0);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBooking = async () => {
            try {
                const res = await axios.get(`${apiUrl}/bookings/getbooking/${bookingId}`);
                if (res?.data?.status === true) {
                    setBooking(res.data.booking);
                }
            } catch (err) {
                setError(err.message || 'Failed to fetch booking');
            } finally {
                setLoading(false);
            }
        };

        fetchBooking();
    }, [bookingId]);

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };



    if (loading) {
        return <Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>;
    }

    if (!booking) {
        return <Typography variant="h6" color="error">Booking not found</Typography>;
    }

    return (
        <Box p={{ xs: 2, md: 4 }}>
            <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} variant="outlined" sx={{ mb: 2 }}>
                Back
            </Button>

            <Paper sx={{ p: 2 }}>
                <Typography variant="h5" gutterBottom>Booking Details</Typography>
                <Tabs value={tab} onChange={handleTabChange} aria-label="booking tabs" sx={{ mb: 2 }} variant="scrollable" scrollButtons="auto">
                    <Tab label="User Info" icon={<PersonIcon />} iconPosition="start" />
                    <Tab label="Booking Info" icon={<InfoIcon />} iconPosition="start" />
                    <Tab label="Services" icon={<ShoppingCartIcon />} iconPosition="start" />
                    <Tab label="Addon Services" icon={<ShoppingCartIcon />} iconPosition="start" />
                    <Tab label="Technician" icon={<ShoppingCartIcon />} iconPosition="start" />
                </Tabs>

                {tab === 0 && (
                    <Box>
                        <Typography variant="h6">User Details</Typography>
                        <Divider sx={{ my: 1 }} />
                        {booking.user ? (
                            <Grid container spacing={2}>
                                {Object.entries(booking.user).map(([key, value], index) => (
                                    <Grid item size={{ xs: 12, sm: 6, sm: 4 }} key={index}>
                                        <Typography variant="body1">
                                            <strong>{key}:</strong> {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography>No user info</Typography>
                        )}
                    </Box>
                )}

                {tab === 1 && (
                    <Box>
                        <Typography variant="h6">Booking Info</Typography>
                        <Divider sx={{ my: 1 }} />
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Status:</strong> {booking.status}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Booking Date:</strong> {booking.bookingDate}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Total Price:</strong> ₹{booking.totalPrice}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Payment Method:</strong> {booking.paymentMethod}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Payment Status:</strong> {booking.paymentStatus}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Booking Type:</strong> {booking.bookingType}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Wallet Used:</strong> ₹{booking.walletAmountUsed}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Delivery Fee:</strong> ₹{booking.deliveryFee}</Typography></Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 4 }}><Typography><strong>Payment Channel:</strong> {booking.paymentChannel}</Typography></Grid>
                        </Grid>
                    </Box>
                )}

                {tab === 2 && (
                    <Box>
                        <Typography variant="h6">Services</Typography>
                        <Divider sx={{ my: 1 }} />
                        {booking.services?.length > 0 ? (
                            <Grid container spacing={2}>
                                {booking.services.map((service, index) => (
                                    <Grid item size={{ xs: 12, sm: 6, sm: 4 }} key={index}>
                                        <Typography><strong>{service.serviceName}</strong> - ₹{service.price}</Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography>No services added</Typography>
                        )}
                    </Box>
                )}

                {tab === 3 && (
                    <Box>
                        <Typography variant="h6">Addon Services</Typography>
                        <Divider sx={{ my: 1 }} />
                        {booking.addonServices?.length > 0 ? (
                            <Grid container spacing={2}>
                                {booking.addonServices.map((addon, index) => (
                                    <Grid item size={{ xs: 12, sm: 6, sm: 4 }} key={index}>
                                        <Typography><strong>{addon.serviceName}</strong> - ₹{addon.price}</Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography>No addon services added</Typography>
                        )}
                    </Box>
                )}
                {/* {tab === 4 && (
                    <Box>
                        <Typography variant="h6">Techinician</Typography>
                        <Divider sx={{ my: 1 }} />
                        {booking.technician ? (
                            <Grid container spacing={2}>
                                {Object.entries(booking.technician).map(([key, value], index) => (
                                    <Grid item size={{ xs: 12, sm: 6, sm: 4 }} key={index}>
                                        <Typography variant="body1">
                                            <strong>{key}:</strong> {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography>No user info</Typography>
                        )}
                    </Box>
                )} */}
                {tab === 4 && (
                    <Box>
                        <Typography variant="h6">Technician</Typography>
                        <Divider sx={{ my: 2 }} />
                        {booking.technician ? (
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={4} md={3}>
                                    {booking.technician.profileImage ? (
                                        <img
                                            src={booking.technician.profileImage}
                                            alt={`${booking.technician.firstName} ${booking.technician.lastName}`}
                                            style={{ width: 120, height: 120, borderRadius: '50%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <Box
                                            sx={{
                                                width: 120,
                                                height: 120,
                                                borderRadius: '50%',
                                                background: '#eee',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 32,
                                                color: '#888'
                                            }}
                                        >
                                            No Image
                                        </Box>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                    <Typography variant="subtitle1">
                                        <strong>Full Name:</strong> {booking.technician.firstName} {booking.technician.lastName}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ) : (
                            <Typography>No technician info</Typography>
                        )}
                    </Box>
                )}



            </Paper>
        </Box>
    );
};

export default BookingDetails;
